import React, { Component } from 'react';
import RouteTitle from '../../../shared/route-title/RouteTitle';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import './WorkingHours.css';
import SelectList from '../../../shared/select/SelectList';
import TextArea from '../../../shared/input/TextArea';
import {
  addWorkingHoursRequest,
  changeOtherWorkingHour,
  selectWorkingHour,
  setCurrentWorkingHours,
} from '../../../../actions/admin/work-orders/creation/working-hours';
import leftArrowPng from '../../../../images/left-arrow.png';
import { goHistoryBack } from '../../../../actions/admin/work-orders/work-orders';
import {
  getOtherWorkingHour,
  getValidationError,
  getWorkingHours,
} from '../../../../selectors/admin/work-orders/creation/working-hours';
import { getCurrentWorkOrder } from '../../../../selectors/admin/work-orders/work-orders';
import { showWOCancellationModal } from '../../../../actions/admin/work-orders/creation/creation';
import CancelWorkOrder from './CancelWorkOrder';
import { getNewWOProcessStarted } from '../../../../selectors/admin/work-orders/creation/creation';
import { simpleScrollToTop } from '../../../../services/utils/scroller-util';

class WorkingHours extends Component {
  componentDidMount() {
    this.props.dispatch(
      setCurrentWorkingHours(
        this.props.currentWorkOrder !== null
          ? this.props.currentWorkOrder.working_hours
          : []
      )
    );
  }

  isValid() {
    return this.props.validationError === '';
  }

  handleWorkingHourSelection = (id) => {
    this.props.dispatch(selectWorkingHour(id));
  };

  handleDescribeOnChange = (value) => {
    this.props.dispatch(changeOtherWorkingHour(value));
  };

  handleContinue = (event) => {
    event.preventDefault();
    const promise = this.props.dispatch(
      addWorkingHoursRequest(
        this.props.currentWorkOrder.id,
        this.props.workingHours,
        this.props.otherWorkingHour
      )
    );

    if (promise !== null) {
      promise.then((response) => {
        if (response.ok) {
          simpleScrollToTop();
        }
      });
    }
  };

  handleBackArrow = () => {
    this.props.dispatch(goHistoryBack());
  };

  handleCancelOrder = (event) => {
    event.preventDefault();
    this.props.dispatch(showWOCancellationModal());
  };

  render() {
    return (
      <div className="working-hours">
        <RouteTitle
          titles={['WORK ORDERS', 'WO #' + this.props.currentWorkOrder.number]}
        />

        <div className="full-title light">
          Work Order #{this.props.currentWorkOrder.number}
        </div>

        <Col md={8} className="column">
          <div className="content-container">
            {
              /* Only show back button if WO is under creation */
              this.props.newWOProcessStarted && (
                <div className="image-back-container">
                  <img
                    src={leftArrowPng}
                    alt={'left-arrow'}
                    onClick={this.handleBackArrow}
                  />
                </div>
              )
            }

            <div className="sub-titles-container">
              <div>Available Working Hours</div>
              <div>Click all the apply:</div>
            </div>

            <div className="working-hours-list">
              <SelectList
                values={this.props.workingHours}
                onSelect={this.handleWorkingHourSelection}
              />

              <div className="text-area-container">
                <TextArea
                  className="text-area-describe"
                  placeholder="Describe..."
                  value={this.props.otherWorkingHour}
                  onChange={this.handleDescribeOnChange}
                />
              </div>
            </div>

            {!this.isValid() ? (
              <div className="invalid-message">
                {this.props.validationError}
              </div>
            ) : null}

            <div className="button-container">
              <input
                className="btn button button-orange"
                value="Continue"
                type="button"
                onClick={this.handleContinue}
              />
              <input
                className="btn button button-white"
                value="Cancel Order"
                type="button"
                onClick={this.handleCancelOrder}
              />
            </div>
          </div>
        </Col>

        <CancelWorkOrder />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    newWOProcessStarted: getNewWOProcessStarted(state),
    otherWorkingHour: getOtherWorkingHour(state),
    validationError: getValidationError(state),
    workingHours: getWorkingHours(state),
  };
})(WorkingHours);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/WorkingHours.js